// src/services/features.service.js
import api from "@/api/axios";

export async function getFeatures() {
  const response = await api.get("/features");
  return response.data;
}